const theme = {
  globalWidthXSmall: '790px',
  globalWidthSmall: '990px',
  globalHeightSmall: '743px',
  globalWidth: '1186px',
  globalWidthLarge: '1816px',
  gutterLarge: '40px',
  gutter: '20px',
  gutterSmall: '10px',
  gutterXSmall: '5px',
  fontFamily: 'museo-sans, sans-serif',
  letterSpace: '0.2px',
  sizes: {
    h1: '3.75rem',
    h2: {
      small: '1.125rem',
      medium: '1.25rem',
      large: '1.5625rem'
    },
    h3: {
      small: '1.125rem',
      medium: '1.125rem',
      large: '1.25rem'
    },
    p: {
      small: '1rem',
      medium: '1.125rem',
      large: '1.25rem'
    },
    small: '0.875rem'
  },
  weights: {
    normal: '500',
    bold: '700'
  },
  colors: {
    white: '#ffffff',
    black: '#000000',
    primary: '#fd5f00',
    info: '#f0f4fa',
    alert: '#fd5f00',
    error: '#e45656',
    valid: '#8fce8f',
    disabled: '#b5b5b5',
    darkFont: '#26272c',
    lightFont: '#1d1d1d',
    disabledFont: '#8e8e8e',
    invertedFont: '#c6d1e2',
    darkBg: '#26272c',
    bg: '#ffffff',
    lightBg: '#f0f4fa',
    border: '#c6d1e2',
    inputText: '#7E8CA0',
    buttonText: '#ffffff',
    buttonBg: '#fd5f00',
    darkButtonBg: '#26272C',
    headerFont: '#ffffff',
    footerFont: '#c6d1e2',
    footerBg: '#26272c'
  }
};

export default theme;
